import React, { useState, useEffect } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { toast } from 'react-toastify';
import axios from 'axios';
import { motion } from 'framer-motion'
import { Users, GraduationCap, Bell, Search, Briefcase } from 'lucide-react'
import Image from '../../../assets/logo.png'
import {
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  IconButton,
  Typography,
  Divider,
  AppBar,
  Toolbar,
} from "@mui/material";
import { Menu, X, User, FileText, Calendar, Home, LogOut } from 'lucide-react';

import AddStaff from "../Staff/AddStaff";
import ManageStaff from "../Staff/ManageStaff";
import AddCommittee from "../Commitee/AddCommitee";
import ManageCommittee from "../Commitee/ManageCmmitee";
import AddEvent from "../Events/AddEvent";
import ManageEvents from "../Events/ManageEvent";
import AddHostel from "../Hostel/AddHostel";
import ManageHostels from "../Hostel/ManageHostel";
import AddTender from "../Tender/AddTender";
import ManageTenders from "../Tender/ManageTender";
import ManageCertificate from "../TransferCertificate/ManageTransfer";
import ManagePayments from "../Payment/ManagePayments";
import SidebarGalleryManagementPage from "../sidebarGallery/sidebargallery";
import MainGallery from '../AdminGalleryy/Gallery';
import AddStudentForm from "../Student/AddStudent";
import ManageStudent from "../Student/ManageStudent";
import ManageTeacherApplications from "../recruitment/manageTeacherApplication";
import AddHigherEducation from "../HigherEducation/AddHigherEducation";
import ManageHigherEducation from "../HigherEducation/ManageHigherEducation";
import AddMouList from "../MouList/AddMou";
import ManageMouList from "../MouList/ManageMou";
import AddProject from "../Projects/addProject";
import ManageProject from "../Projects/manageProject";
import AddVisionMissionForm from "../vissionAndMissionMom/AddV&MMom";
import ManageVisionMission from "../vissionAndMissionMom/ManageV&MMom";
import AddNews from "../newsandupdates/AddnewsAndUpdates";
import AddLaboratory from "../Laboratory/AddLaboratoryPdf";
import AddDeptNewsLetter from "../DeptNewsLetter/AddDeptNewsLetter";

// Sidebar Menu Items
const menuItems = [
  { name: "Add Staff", icon: User, path: "/admin/addstaffform" },
  { name: "Manage Staff", icon: User, path: "/admin/managestaff" },
  { name: "Add Vission And Mission MOM", icon: User, path: "/admin/addV&Mmom" },
  {
    name: "Manage Vission And Mission MOM",
    icon: User,
    path: "/admin/manageV&Mmom",
  },
  { name: "Add Student", icon: User, path: "/admin/addstudentform" },
  { name: "Manage Student", icon: User, path: "/admin/managestudent" },
  { name: "Add Committee", icon: Calendar, path: "/admin/committeeform" },
  { name: "Manage Committees", icon: Calendar, path: "/admin/managecommittee" },
  { name: "Add Event", icon: Calendar, path: "/admin/addeventform" },
  { name: "Manage Events", icon: Calendar, path: "/admin/manageevents" },
  { name: "Add Hostel", icon: Home, path: "/admin/addhostel" },
  { name: "Manage Hostels", icon: Home, path: "/admin/managehostel" },
  { name: "Add Tender", icon: FileText, path: "/admin/addtenderform" },
  { name: "Manage Tenders", icon: FileText, path: "/admin/managetenders" },
  {
    name: "Manage Transfer Certificate",
    icon: FileText,
    path: "/admin/managetransfer",
  },
  { name: "Manage Payments", icon: FileText, path: "/admin/managepayment" },
  {
    name: "Manage Recruitment",
    icon: FileText,
    path: "/admin/manage-recruitment",
  },
  {
    name: "Sidebar Gallery",
    icon: FileText,
    path: "/admin/sidebargallerymanagement",
  },
  { name: "Gallery", icon: FileText, path: "/admin/gallery" },
  {
    name: "Add Higher Education",
    icon: FileText,
    path: "/admin/addHigherEducation",
  },
  {
    name: "Manage Higher Education",
    icon: FileText,
    path: "/admin/manageHigherEducation",
  },
  { name: "Add Mou", icon: FileText, path: "/admin/addmou" },
  { name: "Manage Mou", icon: FileText, path: "/admin/managemou" },
  { name: "Add Project", icon: Briefcase, path: "/admin/addproject" },
  { name: "Manage Project", icon: Briefcase, path: "/admin/manageproject" },
  { name: " News and Updateds", icon: Briefcase, path: "/admin/addnews" },
  {
    name: " Laboratory and Updateds",
    icon: Briefcase,
    path: "/admin/addlaboratory",
  },
  {
    name: " Dept News Letter and Updateds",
    icon: Briefcase,
    path: "/admin/addnewsletter",
  },
];

const AdminDashboard = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const [isLoaded, setIsLoaded] = useState(false)

  useEffect(() => {
    setIsLoaded(true)
  }, [])

  const featuredContent = [
    { title: "Campus Tour", image: "/placeholder.svg?height=200&width=300" },
    { title: "Student Achievements", image: "/placeholder.svg?height=200&width=300" },
    { title: "Latest Facilities", image: "/placeholder.svg?height=200&width=300" },
  ]


  const stats = [
    { title: "Total Students", value: "1,234", icon: Users },
    { title: "Staff Members", value: "89", icon: GraduationCap },
    { title: "Active Events", value: "12", icon: Calendar },
    { title: "Certificates Issued", value: "456", icon: FileText },
  ]

  const recentActivities = [
    "New student registration completed",
    "Monthly staff meeting scheduled",
    "Exam results published",
    "New tender uploaded",
    "Committee meeting minutes added"
  ]

  const upcomingEvents = [
    { title: "Annual Day Celebration", date: "May 15, 2024", image: "/placeholder.svg?height=100&width=100" },
    { title: "Tech Symposium", date: "June 2, 2024", image: "/placeholder.svg?height=100&width=100" },
    { title: "Career Fair", date: "July 10, 2024", image: "/placeholder.svg?height=100&width=100" },
  ]

  useEffect(() => {
    const token = sessionStorage.getItem('authToken');
    // .log("Logged Token:", token);

    if (!token) {
      toast.error('You need to log in to access this page.');
      navigate('/login');
    }
  }, [navigate]);

  const toggleSidebar = () => setIsSidebarOpen((prev) => !prev);

  const handleLogout = () => {
    sessionStorage.removeItem('authToken');
    navigate("/");
  };

  const handleMenuItemClick = () => {
    setIsSidebarOpen(false);
  };

  const renderComponent = () => {
    switch (location.pathname) {
      case "/admin/addstaffform":
        return <AddStaff />;
      case "/admin/managestaff":
        return <ManageStaff />;
      case "/admin/addV&Mmom":
        return <AddVisionMissionForm />;
      case "/admin/manageV&Mmom":
        return <ManageVisionMission />;
      case "/admin/addstudentform":
        return <AddStudentForm />;
      case "/admin/managestudent":
        return <ManageStudent />;
      case "/admin/committeeform":
        return <AddCommittee />;
      case "/admin/managecommittee":
        return <ManageCommittee />;
      case "/admin/addeventform":
        return <AddEvent />;
      case "/admin/manageevents":
        return <ManageEvents />;
      case "/admin/addhostel":
        return <AddHostel />;
      case "/admin/managehostel":
        return <ManageHostels />;
      case "/admin/addmou":
        return <AddMouList />;
      case "/admin/managemou":
        return <ManageMouList />;
      case "/admin/addtenderform":
        return <AddTender />;
      case "/admin/managetenders":
        return <ManageTenders />;
      case "/admin/managetransfer":
        return <ManageCertificate />;
      case "/admin/managepayment":
        return <ManagePayments />;
      case "/admin/manage-recruitment":
        return <ManageTeacherApplications />;
      case "/admin/sidebargallerymanagement":
        return <SidebarGalleryManagementPage />;
      case "/admin/addHigherEducation":
        return <AddHigherEducation />;
      case "/admin/manageHigherEducation":
        return <ManageHigherEducation />;
      case "/admin/gallery":
        return <MainGallery />;
      case "/admin/addproject":
        return <AddProject />;
      case "/admin/manageproject":
        return <ManageProject />;
      case "/admin/addnews":
        return <AddNews />;
      case "/admin/addlaboratory":
        return <AddLaboratory />;
      case "/admin/addnewsletter":
        return <AddDeptNewsLetter />;
      case "/admin/manageproject":
        return <ManageProject />;
      default:
        return (
          <div className="min-h-screen p-6 bg-gray-50">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              className="mx-auto max-w-7xl"
            >
              {/* Welcome Section */}
              <div className="relative mb-8 overflow-hidden md:mb-20 rounded-xl">
                <img
                  src={Image}
                  alt="College campus"
                  width={600}
                  height={100}
                  className="object-cover md:w-[100%] md:h-64 "
                />
                {/* <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50">
                    <div className="text-center">
                      <motion.h1 
                        initial={{ opacity: 0, y: -20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.2 }}
                        className="text-4xl font-bold text-white"
                      >
                        Welcome to Admin Dashboard
                      </motion.h1>
                      <motion.p 
                        initial={{ opacity: 0, y: -20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.3 }}
                        className="mt-2 text-white"
                      >
                        Government Women's Polytechnic College, Sehore
                      </motion.p>
                    </div> 
                  </div>*/}
              </div>

              {/* Stats Grid */}
              <div className="grid grid-cols-1 gap-6 mb-8 md:mb-20 md:grid-cols-2 lg:grid-cols-4">
                {stats.map((stat, index) => (
                  <motion.div
                    key={stat.title}
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.1 * (index + 1) }}
                    className="p-6 bg-white rounded-lg shadow-md"
                  >
                    <div className="flex items-center justify-between">
                      <div>
                        <p className="text-sm font-medium text-gray-600">
                          {stat.title}
                        </p>
                        <h3 className="mt-2 text-2xl font-bold text-gray-800">
                          {stat.value}
                        </h3>
                      </div>
                      <div className="p-3 bg-gray-100 rounded-full">
                        <stat.icon className="w-6 h-6 text-gray-600" />
                      </div>
                    </div>
                  </motion.div>
                ))}
              </div>

              {/* Main Content Grid */}
              <div className="grid grid-cols-1 gap-6 lg:grid-cols-3 md:mb-20">
                {/* Quick Search */}
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.6 }}
                  className="p-6 bg-white rounded-lg shadow-md lg:col-span-2"
                >
                  <h2 className="mb-4 text-xl font-bold text-gray-800">
                    Quick Search
                  </h2>
                  <div className="relative">
                    <input
                      type="text"
                      placeholder="Search students, staff, or resources..."
                      className="w-full p-3 pr-10 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-gray-200"
                    />
                    <Search className="absolute text-gray-400 transform -translate-y-1/2 right-3 top-1/2" />
                  </div>
                </motion.div>

                {/* Recent Activities */}
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.7 }}
                  className="p-6 bg-white rounded-lg shadow-md"
                >
                  <h2 className="mb-4 text-xl font-bold text-gray-800">
                    Recent Activities
                  </h2>
                  <div className="space-y-4">
                    {recentActivities.map((activity, index) => (
                      <motion.div
                        key={index}
                        initial={{ opacity: 0, x: 20 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ delay: 0.1 * (index + 1) }}
                        className="flex items-center gap-3 p-3 transition-colors rounded-lg bg-gray-50 hover:bg-gray-100"
                      >
                        <div className="w-2 h-2 bg-gray-400 rounded-full" />
                        <p className="text-sm text-gray-600">{activity}</p>
                      </motion.div>
                    ))}
                  </div>
                </motion.div>
              </div>

              {/* Featured Content */}
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.8 }}
                className="p-6 mt-6 bg-white rounded-lg shadow-md"
              >
                <h2 className="mb-4 text-xl font-bold text-gray-800">
                  Featured Content
                </h2>
                <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
                  {featuredContent.map((item, index) => (
                    <motion.div
                      key={index}
                      initial={{ opacity: 0, y: 20 }}
                      animate={{ opacity: 1, y: 0 }}
                      transition={{ delay: 0.1 * (index + 1) }}
                      className="relative overflow-hidden rounded-lg"
                    >
                      <img
                        src={item.image}
                        alt={item.title}
                        width={300}
                        height={200}
                        className="object-cover w-full h-48"
                      />
                      <div className="absolute inset-0 flex items-end justify-start p-4 bg-black bg-opacity-40">
                        <h3 className="font-semibold text-white">
                          {item.title}
                        </h3>
                      </div>
                    </motion.div>
                  ))}
                </div>
              </motion.div>

              {/* Notifications */}
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.9 }}
                className="p-6 mt-6 bg-white rounded-lg shadow-md"
              >
                <div className="flex items-center justify-between mb-4">
                  <h2 className="text-xl font-bold text-gray-800">
                    Notifications
                  </h2>
                  <Bell className="text-gray-600" />
                </div>
                <div className="space-y-4">
                  {[
                    "New student application received",
                    "Staff meeting reminder: Tomorrow at 10 AM",
                    "Update required: Latest attendance records",
                    "Maintenance scheduled for computer lab",
                    "New government circular available for review",
                  ].map((notification, index) => (
                    <motion.div
                      key={index}
                      initial={{ opacity: 0, x: -20 }}
                      animate={{ opacity: 1, x: 0 }}
                      transition={{ delay: 0.1 * (index + 1) }}
                      className="flex items-center gap-3 p-3 transition-colors rounded-lg bg-gray-50 hover:bg-gray-100"
                    >
                      <div className="w-2 h-2 bg-blue-500 rounded-full" />
                      <p className="text-sm text-gray-600">{notification}</p>
                    </motion.div>
                  ))}
                </div>
              </motion.div>
            </motion.div>
          </div>
        );
    }
  };

  return (
    <div className="flex min-h-auto">
      <Drawer
        variant="persistent"
        anchor="left"
        open={isSidebarOpen}
        onClose={() => setIsSidebarOpen(false)}
        classes={{ paper: "w-64" }}
      >
  <div className="flex items-center justify-between px-6 py-4 bg-gradient-to-r from-teal-400 to-teal-500 shadow-md border-b animate-fadeIn">
  <div className="flex space-x-4">
    <NavLink
      to="/"
      className="px-4 py-2 bg-white text-teal-600 font-semibold rounded-lg shadow transition-transform duration-300 hover:scale-105 hover:bg-teal-100 hover:text-teal-800"
      onClick={handleMenuItemClick}
    >
      Home
    </NavLink>
    <NavLink
      to="/admin/dashboard"
      className="px-4 py-2 bg-white text-teal-600 font-semibold rounded-lg shadow transition-transform duration-300 hover:scale-105 hover:bg-teal-100 hover:text-teal-800"
      onClick={handleMenuItemClick}
    >
      Admin Panel
    </NavLink>
  </div>
  <button
    onClick={toggleSidebar}
    className="text-white hover:bg-teal-600 p-2 rounded-full transition-transform duration-300 hover:rotate-90"
  >
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="w-6 h-6">
      <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
    </svg>
  </button>
</div>



        <Divider />
        <List>
          {menuItems.map((item) => (
            <ListItem key={item.name} className="hover:bg-gray-100">
              <NavLink
                to={item.path}
                className="flex items-center w-full"
                style={{ textDecoration: "none", color: "inherit" }}
                onClick={handleMenuItemClick}
              >
                <ListItemIcon>
                  <item.icon className="text-teal-500" />
                </ListItemIcon>
                <ListItemText primary={item.name} />
              </NavLink>
            </ListItem>
          ))}
          <ListItem
            button
            onClick={() => {
              handleLogout();
              handleMenuItemClick();
            }}
            className="font-extrabold bg-teal-300 hover:cursor-pointer hover:text-teal-500"
            style={{ marginTop: "auto" }}
          >
            <ListItemIcon>
              <LogOut className="text-red-500" />
            </ListItemIcon>
            <ListItemText primary="Log Out" />
          </ListItem>
        </List>
      </Drawer>

      <div className="flex flex-col flex-1">
        <AppBar position="sticky" color="default" className="shadow-sm">
          <Toolbar className="flex justify-between">
            <div className="flex items-center space-x-4">
              <IconButton edge="start" onClick={toggleSidebar}>
                <Menu />
              </IconButton>
            </div>
          </Toolbar>
        </AppBar>

        <main className="flex-1 p-4 overflow-auto">{renderComponent()}</main>
      </div>
    </div>
  );
};

export default AdminDashboard;